import { render, staticRenderFns } from "./SubjectBalance.vue?vue&type=template&id=fc1c950c&scoped=true"
import script from "./SubjectBalance.vue?vue&type=script&lang=js"
export * from "./SubjectBalance.vue?vue&type=script&lang=js"
import style0 from "./SubjectBalance.vue?vue&type=style&index=0&id=fc1c950c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1c950c",
  null
  
)

export default component.exports